import { render, staticRenderFns } from "./ContactBlock.vue?vue&type=template&id=c4ddc858&scoped=true"
import script from "./ContactBlock.vue?vue&type=script&lang=ts"
export * from "./ContactBlock.vue?vue&type=script&lang=ts"
import style0 from "./ContactBlock.vue?vue&type=style&index=0&id=c4ddc858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ddc858",
  null
  
)

export default component.exports